(() => {
  const selector = '[data-contact-experience]';

  function init(section) {
    if (!section || section.dataset.contactReady === 'true') return;
    section.dataset.contactReady = 'true';

    section.querySelectorAll('[data-contact-faq]').forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        section.querySelectorAll('[data-contact-faq][open]').forEach((other) => {
          if (other !== item) other.removeAttribute('open');
        });
      });
    });

    const success = section.querySelector('[data-contact-success]');
    if (success) success.focus({ preventScroll: true });
  }

  function initAll(root = document) {
    if (root.matches?.(selector)) init(root);
    root.querySelectorAll(selector).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
